



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Collection } from '@/resource/collection/collection.model';
import Modal from '@/main-components/common/modal/Modal.vue';
import Form, {
  InputData,
  OnSubmitReturn,
} from '@/main-components/common/Form.vue';
import replaceFormInputValue from '@/utils/form/replace-form-input-value';
import { DropdownSubjectValue } from '@/utils/form/form-input-typing';

export interface UpdatePaper {
  name: string;
  subject: DropdownSubjectValue;
}

@Component({
  components: {
    Modal,
    Form,
  },
})
export default class ModalEditPaper extends Vue {
  @Prop({ required: true })
  paper: Collection;

  @Prop({ required: true })
  updatePaper: (params: UpdatePaper) => Promise<OnSubmitReturn | null>;

  openModal: any = null;
  closeModal: any = null;

  inputs: InputData[] = [
    {
      name: 'name',
      value: '',
      placeholder: 'Paper’s name',
      type: 'text',
      isRequired: true,
      maxLength: 80,
    },
    {
      name: 'subject',
      value: {
        selectedSubject: null,
        selectedForm: null,
        selectedChapter: null,
        selectedChapters: [],
      },
      type: 'dropdown-subject',
      isRequired: true,
      isHideForm: true,
      isHideChapter: true,
    },
  ];

  @Watch('paper')
  onPaperChange() {
    if (this.paper) {
      replaceFormInputValue(this.inputs, 'name', this.paper.name);

      if (this.paper.subject) {
        replaceFormInputValue(this.inputs, 'subject', {
          selectedSubject: this.paper.subject.uuid,
          selectedForm: null,
          selectedChapter: null,
          selectedChapters: [],
        });
      }
    }
  }

  mounted() {
    this.$emit('openModalEditPaperAdd', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }
}
